export default __webpack_public_path__ + "static/media/hearing.6a807264.webp";